// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateOrganizationBindingManager, ValidateCreateOrganizationBindingManagerSchema } from 'api/gen/ValidateCreateOrganizationBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateOrganizationBindingManager, ValidateUpdateOrganizationBindingManagerSchema } from 'api/gen/ValidateUpdateOrganizationBindingManager';

export const ValidateOrganizationBindingManagerSchema = t.union([ValidateCreateOrganizationBindingManagerSchema, ValidateUpdateOrganizationBindingManagerSchema]);

export type ValidateOrganizationBindingManager = t.TypeOf<typeof ValidateOrganizationBindingManagerSchema>;
